/** 股票相关常量数据 */

export const MARKET_TYPE = {
  ALL: 'ALL', // 所有类型
  US: 'US', // 美股
  HK: 'HK', // 港股
  UK: 'UK', // 英股
  CN: 'CN', // A 股
  A: ['SH', 'SZ'], // A 股
  SZ: 'SZ', // 深圳交易所
  SH: 'SH', // 上海交易所
  FUT: 'FUT' // 期货市场
}

// 市场名称
export const MARKET_NAME = {
  ALL: 'all', // 全部
  US: 'usMarket', // 美股
  HK: 'hkMarket', // 港股
  A: 'aMarket', // A 股
  UK: 'ukMarket', // 英股
  OPT: 'opt', // 期权
  FUT: 'fut', // 期货
  HOLD: 'holding' // 持仓
}

// 股票类型
export const STOCK_TYPE = {
  STK: 0, // 股票
  PLATE: 1, // 板块
  WAR_CHAIN: 2, // 窝轮链
  WAR: 3, // 窝轮
  CBBC: 4, // 牛熊证
  FUT: 5, // 期货
  OTC: 6 // 场外交易市场
}

// 股票停牌状态
export const STOCK_HALTED_STATUS = {
  NORMAL: 0, // 正常
  HALTED: 3, // 停牌
  DELISTED: 4, // 退市
  NEW: 7, // 新股
  CHANGED: 8, // 变更
  ACTION: 9 // 公司行动
}

// 合约类型
export const SEC_TYPE = {
  ALL: 'ALL', // 所有
  STK: 'STK', // 股票
  FUT: 'FUT', // 期货
  WAR: 'WAR', // 港股窝轮
  IOPT: 'IOPT', // 港股牛熊证
  OPT: 'OPT', // 期权
  FOP: 'FOP', // 期货期权
  CASH: 'CASH', // IB 账户换汇交易
  FOREX: 'FOREX' // 标准账户换汇交易
}

// A 股中上交所股票代码前缀
export const SH_SYMBOL_PREFIX = [
  '00',
  '03',
  '07',
  '08',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '18',
  '20',
  '23',
  '28',
  '30',
  '36',
  '37',
  '38',
  '39'
]

// 交易状态
export const TRADING_STATUS = {
  UNOPENED: 0, // 未交易
  PRE_TRADING: 1, // 盘前交易（盘前竞价）
  TRADING: 2, // 交易中
  POST_TRADING: 3 // 盘后交易（收市竞价）
}

// 市场状态
export const MARKET_STATUS = {
  UNOPENED: 0, // 未开盘
  PRE_TRADING: 1, // 盘前交易（US）、开市前（HK）、集合竞价（CN）、开盘竞价（UK）
  TRADING: 2, // 交易中
  NOON_CLOSED: 3, // 午间休市
  CLOSING_AUCTION: 4, // 收市竞价
  TRADE_CLOSED: 5, // 休盘
  EARLY_CLOSED: 6, // 提前休市
  CLOSED: 7 // 休市
}

// 分时图行情展示类型
export const TREND_TYPE = {
  // 全部行情
  ALL: 0,
  // 盘前行情
  PRE: 1,
  // 盘中行情
  IN: 2,
  // 盘后行情
  AFTER: 3
}

export const STOCK_ALERT_CATEGORY = {
  // 股价提醒
  PRICE: 1,
  // 盘口提醒
  HANDICAP: 2,
  // 技术指标提醒
  INDEX: 3
}

// 股价提醒类型
export const PRICE_ALERT_TYPE = {
  // 涨至
  RISE_TO: 101,
  // 跌至
  DROP_TO: 102,
  // 今日涨超
  TODAY_RISE_OVER: 103,
  // 今日跌超
  TODAY_DROP_OVER: 104,
  // 五分涨超
  FIVE_RISE_OVER: 105,
  // 五分跌超
  FIVE_DROP_OVER: 106,
  // 52周最高
  YEAR_HIGHEST: 107,
  // 52周最低
  YEAR_LOWEST: 108
}

// 盘口提醒类型
export const POS_ALERT_TYPE = {
  // 成交额超
  TURNOVER_OVER: 201,
  // 成交量超
  VOLUME_OVER: 202,
  // 换手率超
  TURNOVER_RATE_OVER: 203,
  // 买一档量超
  ASK_1_VOLUME_OVER: 204,
  // 卖一档量超
  BID_1_VOLUME_OVER: 205,
  // 买一档价格超
  ASK_1_PRICE_OVER: 206,
  // 卖一档价格超
  BID_1_PRICE_OVER: 207
}

export const PRICE_ALERT_FREQUENCY = {
  // 一次提醒
  ONCE: 1,
  // 每天一次提醒
  ONCE_A_DAY: 2,
  // 一直提醒
  ALWAYS: 3
}
